import styled from '@emotion/styled';

export const ContentContainer = styled.div`
  display: contents;
  &.hidden {
    display: none;
  }
`;
